import { useGetTypesenseDocumentById } from '../document';

export const useGetEmployeeById = (
  employeeId: string | number | null | undefined,
  {
    apiKeyName = 'employees',
    enabled = true,
  }: {
    apiKeyName?:
      | 'employees'
      | 'projectmanagers'
      | 'accountmanagers'
      | 'partners';
    enabled?: boolean;
  } = {},
) => {
  const id = employeeId != null ? String(employeeId) : null;
  return useGetTypesenseDocumentById({
    collection: 'employees',
    idField: 'SourceId',
    apiKeyName,
    entityId: id,
    enabled,
  });
};
